import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { GradesTableProps } from './types';
import GradesTableContent from './GradesTableContent';
import GradesTableQueryClientProvider from './GradesTableQueryClientProvider';
import GradesTableStoreProvider from './store/GradesTableStoreProvider';
import Navigation from './Navigation';

export const GradesTable = () => (
  <div>
    <Navigation />
    <GradesTableContent />
  </div>
);

const GradesTableWrapper = (props: GradesTableProps) => (
  <BrowserRouter basename="/teacher/scores">
    <GradesTableStoreProvider props={props}>
      <GradesTableQueryClientProvider>
        <Routes>
          <Route path=":classroomId" element={<GradesTable />} />
        </Routes>
      </GradesTableQueryClientProvider>
    </GradesTableStoreProvider>
  </BrowserRouter>
);

export default GradesTableWrapper;
